const excludedRoutes = ['/login', '/signup'];

export const isExcludedRoute = (path: string) => excludedRoutes.includes(path);

export default excludedRoutes;
